import './Card.scss'

export const CARD_EMPHASIS = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    TERTIARY: 'tertiary',
}

export default ({
                    className,
                    isNegative = false,
                    isPositive = false,
                    isError = false,
                    isWarning = false,
                    isInfo = false,
                    emphasis = CARD_EMPHASIS.PRIMARY,
                    ...restOfProps
                }) => {
    return (
        <div
            className={`
                card ${className}
                emphasis-${emphasis}
                ${isPositive ? 'is-positive' : ''}
                ${isNegative ? 'is-negative' : ''}
                ${isError ? 'is-error' : ''}
                ${isWarning ? 'is-warning' : ''}
                ${isInfo ? 'is-info' : ''}
            `}
            {...restOfProps}
        />
    )
}